/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateStowageInstructionCommand } from '../model';
// @ts-ignore
import type { StowageInstructionResponseDto } from '../model';
// @ts-ignore
import type { UpdateStowageInstructionCommand } from '../model';
/**
 * StowageInstructionsApi - axios parameter creator
 */
export const StowageInstructionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateStowageInstructionCommand} [createStowageInstructionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stowageInstructionsCreate: async (createStowageInstructionCommand?: CreateStowageInstructionCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/StowageInstructions/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStowageInstructionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stowageInstructionsDelete: async (ids: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('stowageInstructionsDelete', 'ids', ids)
            const localVarPath = `/storage/api/StowageInstructions/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (ids) {
                localVarQueryParameter['Ids'] = ids;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stowageInstructionsGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/StowageInstructions/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateStowageInstructionCommand} [updateStowageInstructionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stowageInstructionsUpdate: async (updateStowageInstructionCommand?: UpdateStowageInstructionCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/StowageInstructions/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateStowageInstructionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StowageInstructionsApi - functional programming interface
 */
export const StowageInstructionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StowageInstructionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateStowageInstructionCommand} [createStowageInstructionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stowageInstructionsCreate(createStowageInstructionCommand?: CreateStowageInstructionCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stowageInstructionsCreate(createStowageInstructionCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StowageInstructionsApi.stowageInstructionsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stowageInstructionsDelete(ids: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stowageInstructionsDelete(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StowageInstructionsApi.stowageInstructionsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stowageInstructionsGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StowageInstructionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stowageInstructionsGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StowageInstructionsApi.stowageInstructionsGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateStowageInstructionCommand} [updateStowageInstructionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stowageInstructionsUpdate(updateStowageInstructionCommand?: UpdateStowageInstructionCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stowageInstructionsUpdate(updateStowageInstructionCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StowageInstructionsApi.stowageInstructionsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StowageInstructionsApi - factory interface
 */
export const StowageInstructionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StowageInstructionsApiFp(configuration)
    return {
        /**
         * 
         * @param {StowageInstructionsApiStowageInstructionsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stowageInstructionsCreate(requestParameters: StowageInstructionsApiStowageInstructionsCreateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.stowageInstructionsCreate(requestParameters.createStowageInstructionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StowageInstructionsApiStowageInstructionsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stowageInstructionsDelete(requestParameters: StowageInstructionsApiStowageInstructionsDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.stowageInstructionsDelete(requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stowageInstructionsGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<StowageInstructionResponseDto>> {
            return localVarFp.stowageInstructionsGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StowageInstructionsApiStowageInstructionsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stowageInstructionsUpdate(requestParameters: StowageInstructionsApiStowageInstructionsUpdateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.stowageInstructionsUpdate(requestParameters.updateStowageInstructionCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for stowageInstructionsCreate operation in StowageInstructionsApi.
 */
export interface StowageInstructionsApiStowageInstructionsCreateRequest {
    readonly createStowageInstructionCommand?: CreateStowageInstructionCommand
}

/**
 * Request parameters for stowageInstructionsDelete operation in StowageInstructionsApi.
 */
export interface StowageInstructionsApiStowageInstructionsDeleteRequest {
    readonly ids: Array<string>
}

/**
 * Request parameters for stowageInstructionsUpdate operation in StowageInstructionsApi.
 */
export interface StowageInstructionsApiStowageInstructionsUpdateRequest {
    readonly updateStowageInstructionCommand?: UpdateStowageInstructionCommand
}

/**
 * StowageInstructionsApi - object-oriented interface
 */
export class StowageInstructionsApi extends BaseAPI {
    /**
     * 
     * @param {StowageInstructionsApiStowageInstructionsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stowageInstructionsCreate(requestParameters: StowageInstructionsApiStowageInstructionsCreateRequest = {}, options?: RawAxiosRequestConfig) {
        return StowageInstructionsApiFp(this.configuration).stowageInstructionsCreate(requestParameters.createStowageInstructionCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StowageInstructionsApiStowageInstructionsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stowageInstructionsDelete(requestParameters: StowageInstructionsApiStowageInstructionsDeleteRequest, options?: RawAxiosRequestConfig) {
        return StowageInstructionsApiFp(this.configuration).stowageInstructionsDelete(requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stowageInstructionsGetAll(options?: RawAxiosRequestConfig) {
        return StowageInstructionsApiFp(this.configuration).stowageInstructionsGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StowageInstructionsApiStowageInstructionsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stowageInstructionsUpdate(requestParameters: StowageInstructionsApiStowageInstructionsUpdateRequest = {}, options?: RawAxiosRequestConfig) {
        return StowageInstructionsApiFp(this.configuration).stowageInstructionsUpdate(requestParameters.updateStowageInstructionCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

